import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Process from "@/pages/Process";
import Certifications from "@/pages/Certifications";
import Contact from "@/pages/Contact";
import RFQ from "@/pages/RFQ";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App grain-overlay dark">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/:id" element={<ProductDetail />} />
            <Route path="/process" element={<Process />} />
            <Route path="/certifications" element={<Certifications />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/rfq" element={<RFQ />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
